class LocalStorageService {
  save<T>(key: string, object: T): void {
    const json = JSON.stringify(object);
    localStorage.setItem(key, json);
  }

  get<T>(key: string): T | null {
    const json = localStorage.getItem(key);
    if (json) {
      return JSON.parse(json) as T;
    }
    return null;
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
}

export default new LocalStorageService();

export const LocalStorageKeys = {
  CachedSearchString: 'search-string',
  CachedReleaseId: 'RELEASE_ID',
  CachedLastProjectId: 'LAST_PROJECT',
  CachedSortType: 'SORT_TYPE',
  CachedScrollBar: 'SCROLL',
  CachedLineScrollBar: 'LINE_SCROLL',
  CachedDesktopSidebarOpen: 'DESKTOP_SIDEBAR_OPEN',
  CachedKanbanProjectScope: 'KANBAN_PROJECT_SCOPE',
  CachedKanbanShowEndedProjects: 'KANBAN_SHOW_ENDED_PROJECTS',
  CachedFinanceComposeClientSelection: 'FINANCE_COMPOSE_CLIENT_SELECTION',
} as const;
